import { lazyLoad } from 'app/utils/loadable'

export const MarketDataSubscriptionsPage = lazyLoad(
  () => import('./index'),
  module => module.MarketDataSubscriptionsPage
)
